// Przestrzeń nazw 'satisfaction': ekran Satysfakcja mieszkańców. Kolejność jak w mockupie
// (renderSatysfakcja): średnia ocena z rozkładem, potem cytaty mieszkańców.
export default {
  rating: {
    title: 'Średnia ocena rozmów',
    // VERIFY: mockup ma „Mieszkaniec ocenia rozmowę na jej końcu, w skali 1–5". Nasze oceny
    // przychodzą SMS-em po rozmowie, na skali 1–10 (na ekranie przeliczonej na 5 gwiazdek).
    hint: 'Mieszkańcy oceniają rozmowę SMS-em po jej zakończeniu, w skali od 1 do 10.',
    // Mockup: „/ 5 · N ocen".
    caption_one: '/ 5 · {{count, number}} ocena',
    caption_few: '/ 5 · {{count, number}} oceny',
    caption_many: '/ 5 · {{count, number}} ocen',
    caption_other: '/ 5 · {{count, number}} oceny',
    // VERIFY: brak w mockupie, etykieta słupka dla czytnika ekranu (na ekranie „5 ★").
    stars_one: '{{count}} gwiazdka',
    stars_few: '{{count}} gwiazdki',
    stars_many: '{{count}} gwiazdek',
    stars_other: '{{count}} gwiazdki',
    // VERIFY: cały blok komunikatów, brak w mockupie.
    messages: {
      headlineError: 'Nie udało się wczytać oceny.',
      headlineLoading: 'Ładowanie oceny…',
      distributionError: 'Nie udało się wczytać rozkładu ocen.',
      distributionLoading: 'Ładowanie rozkładu ocen…',
      distributionEmpty: 'Brak rozmów w tym okresie.',
    },
  },

  // Podpis pod słupkami. Słupki liczą ograniczoną próbkę najnowszych ocen, więc mogą obejmować
  // mniej niż nagłówek; podpis jako jedyny to pokazuje. Składany z fraz w tej kolejności:
  // `bars` [`ofTotal`] `scope*` [`unscored`], rozdzielonych przecinkami, na końcu kropka.
  // VERIFY: cały blok, brak w mockupie.
  sample: {
    bars_one: 'Słupki obejmują {{count, number}} ocenę',
    bars_few: 'Słupki obejmują {{count, number}} oceny',
    bars_many: 'Słupki obejmują {{count, number}} ocen',
    bars_other: 'Słupki obejmują {{count, number}} oceny',
    ofTotal: 'z {{responses, number}} w okresie',
    // Próbka uciętą przez limit zapytania: najnowsze rozmowy.
    scopeRecent_one: 'z ostatniej rozmowy w tym okresie',
    scopeRecent_few: 'z {{count, number}} ostatnich rozmów w tym okresie',
    scopeRecent_many: 'z {{count, number}} ostatnich rozmów w tym okresie',
    scopeRecent_other: 'z {{count, number}} ostatnich rozmów w tym okresie',
    // Próbka obejmuje cały okres.
    scopeAll_one: 'z jedynej rozmowy w tym okresie',
    scopeAll_few: 'ze wszystkich {{count, number}} rozmów w tym okresie',
    scopeAll_many: 'ze wszystkich {{count, number}} rozmów w tym okresie',
    scopeAll_other: 'ze wszystkich {{count, number}} rozmów w tym okresie',
    // Odpowiedź słowna bez oceny liczbowej (zero).
    unscored_one: 'a {{count, number}} odpowiedź wróciła jako tekst bez oceny',
    unscored_few: 'a {{count, number}} odpowiedzi wróciły jako tekst bez oceny',
    unscored_many: 'a {{count, number}} odpowiedzi wróciło jako tekst bez oceny',
    unscored_other: 'a {{count, number}} odpowiedzi wróciły jako tekst bez oceny',
  },

  quotes: {
    title: 'Co mówią mieszkańcy',
    // VERIFY: mockup ma „Fragmenty ocen głosowych zostawionych po rozmowie"; nasze cytaty to
    // odpowiedzi tekstowe wysłane SMS-em, od najnowszych.
    hint: 'Odpowiedzi mieszkańców wysłane SMS-em po rozmowie, od najnowszych.',
    // Cytat w polskim cudzysłowie, jak w mockupie.
    text: '„{{text}}”',
    topic: 'Sprawa: {{topic}}',
    // VERIFY: cały blok komunikatów, brak w mockupie.
    messages: {
      error: 'Nie udało się wczytać odpowiedzi mieszkańców.',
      loading: 'Ładowanie odpowiedzi mieszkańców…',
      // Czytana jest jedna strona odpowiedzi, więc pusty wynik mówi tylko o niej.
      noWords_one: 'Brak słów w ostatniej odpowiedzi, tylko ocena.',
      noWords_few: 'Brak słów w {{count}} ostatnich odpowiedziach, tylko oceny.',
      noWords_many: 'Brak słów w {{count}} ostatnich odpowiedziach, tylko oceny.',
      noWords_other: 'Brak słów w {{count}} ostatnich odpowiedziach, tylko oceny.',
      noRatings: 'Żaden mieszkaniec nie ocenił rozmowy w tym okresie.',
    },
  },
} as const;
